<template>
  <div class="editor-container">
    <Toolbar
      style="border-bottom: 1px solid #ccc"
      :editor="editor"
      :defaultConfig="toolbarConfig"
      :mode="mode"
    />
    <Editor
      style="height: 300px; overflow-y: hidden;"
      v-model="html"
      :mode="mode"
      @onCreated="onCreated"
      @customPaste="customPaste"
    />
  </div>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'

export default {
  name: 'wEditor',
  components: {
    Editor,
    Toolbar
  },
  data () {
    return {
      // 富文本
      html: '',
      toolbarConfig: { 
        excludeKeys: ['emotion', 'group-video', 'group-image',]
      },
      editor: null,
      mode: 'default',
    }
  },
  props: {
    context: {
      type: String,
      default: ''
    }
  },
  watch: {
    context: {
      handler (val) {
        this.html = val
      },
      immediate: true,
    }
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
  methods: {
    // 富文本
    customPaste(editor, event, callback) {
      const text = event.clipboardData.getData('text/plain') // 获取粘贴的纯文本

      // 自定义插入内容
      editor.insertText(text)

      // 返回 false ，阻止默认粘贴行为
      event.preventDefault()
      callback(false) // 返回值（注意，vue 事件的返回值，不能用 return）

      // 返回 true ，继续默认的粘贴行为
      // callback(true)
    },
    onCreated(editor) {
      editor.insertBreak = function () {
        editor.dangerouslyInsertHtml(`<br>`)
      }
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
  }
}
</script>

<style>

</style>